import React, { useContext } from 'react';
import { AuthContext } from '../../context/auth';
import Header from '../../components/Header';
import MenuJuegos from '../../components/hacienda/juegoApuestas/menuJuegosLicitos';
import Barra from '../../components/barra';
import imagen from '../../imagenes/apuestas_licitas.png';
import Footer from '../../../src/components/Footer';

function JuegosApuestas() {

  let op = require('../../../src/modulos/datos');
  const { user } = useContext(AuthContext);
  let per = JSON.parse(localStorage.getItem('permisos'));

  return (

    user && (

      <div style={{ height: "100vh", padding: 0 }}>
        <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
          <Header />
        </div>
        <div className="row col-md-12" style={{ height: "85%", padding: 0, margin: 0 }}>

          <div className="col-md-12" style={{ height: "100%", padding: 0 }}>
            <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
              <MenuJuegos
                permisos={per}
              />
            </div>
            <div className="col-md-12" style={{ height: "90%", padding: 0, background: "#0e5694" }}>

              <img src={imagen} alt="" height="100%" width="100%" />

    
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ height: "5%", padding: 0 }}>
          <Footer />
        </div>
      </div>

    )


  );
}


export default JuegosApuestas;
